import { ReactNode } from 'react';
import { Column, Filters } from 'react-table';

type BaseTableProps<T> = {
    data: Array<T>;
    fetchData: BaseTableFetchFuncProps;
    pageCount: number;
    defaultColumnConfig: Column[];
    defaultVisibleColumnConfig?: string[];
    defaultColumnIdToSortBy?: string;
    defaultSortingType?: SortingType;
    isExpandable?: boolean;
    previewComponent?: ({ row: { original } }: { row: { original: any } }) => ReactNode | string;
    onClick?: () => void;
    onClickDownload?: () => void;
    defaultFilters?: Filters<any>;
    hideSearch?: boolean;
    hideColumnSelector?: boolean;
    hidePagination?: boolean;
    onRowClick?: (row: any) => void;
    defaultSearchTerm?: string;
    defaultPageSize?: number;
    defaultPageIndex?: number;
    onColumnsVisibilityChange?: (visibleColumns: string[]) => void;
};

export default BaseTableProps;

export enum SortingType {
    Descending = 'Descending',
    Ascending = 'Ascending',
}

export type BaseTableFetchFuncProps = ({
    pageSize,
    pageIndex,
    sortingType,
    sortBy,
    filters,
    searchTerm,
}: {
    pageSize: number;
    pageIndex: number;
    sortingType?: SortingType;
    sortBy?: string;
    filters: Filters<any>;
    searchTerm?: string | null | undefined;
}) => Promise<void>;

export type SortingParam = {
    sortingType?: SortingType;
    sortBy?: string;
    searchTerm?: string;
};

export type PaginationParam = {
    pageSize: number;
    pageIndex: number;
};
